import styled from 'styled-components';
import {InputContainer} from '../Input/styles';

export const InputListTag = styled.ul`
  width: 100%;
`;

export const InputItem = styled.li`
  &:first-child ${InputContainer} {
    border-bottom-color: transparent;
    border-radius: 6px 6px 0 0;
    
    &:hover {
      border-bottom-color: ${({ theme }) => theme.blue};
    }
  }
  
  &:last-child ${InputContainer} {
    border-top-color: transparent;
    border-radius: 0 0 6px 6px;
    
    &:hover {
      border-top-color: ${({ theme }) => theme.blue};
    }
  }
  
  &:first-child + &:last-child {
    border-top: 1px solid #ebebeb;
  }
  
  &:last-child + &:first-child {
    border-bottom: 1px solid #ebebeb;
  }
  
  &:not(:first-child):not(:last-child) {
    border-radius: 6px;
  }
  
  &:first-child:last-child ${InputContainer} {
    border: 1px solid #ebebeb;
    border-radius: 6px;
    
    &:hover {
      border-color: ${({ theme }) => theme.blue};
    }
  }
`;
